module.exports = __webpack_public_path__ + "static/img/8256_phase_function_Paper_PointsHejduk_Prediction.f20c203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8256_phase_function_Paper_PointsHejduk_Prediction.png
// module id = t3gO
// module chunks = 0